import {
  useModalContext,
  WSFlexBox,
  WSForm,
  WSModal,
  WSText,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import * as Yup from "yup";
import React from "react";
import { ErrorContextKey } from "../../services/platform";
import { WSErrorMessage } from "../WSErrorMessage/WSErrorMessage";
import { useCreateOtpSession } from "../../query/users/mutations";
import styles from "./styles.module.scss";
import { SELECT_2FA_CHANNEL_FORM_MODAL } from "../../MemberOnboarding/screens/Select2FAChannelForm";

export const SESSION_OTP_MODAL = "SESSION_OTP_MODAL";

export const SessionOTPModal: React.FC = () => {
  const { closeModal } = useModalContext();
  const [createOtpSession, createOtpSessionMeta] = useCreateOtpSession();
  const onFormSubmit = async (
    data: any,
    onSuccessVerifyOtp: () => void = () => {}
  ) => {
    await createOtpSession(
      {
        code: data.otp
      },
      {
        onSuccess: () => {
          closeModal(SESSION_OTP_MODAL);
          closeModal(SELECT_2FA_CHANNEL_FORM_MODAL);
          onSuccessVerifyOtp();
        }
      }
    );
  };
  return (
    <WSModal
      name={SESSION_OTP_MODAL}
      size="M"
      fullScreen
      fullScreenOnMobile
      className={styles.modalBody}
    >
      {({ onSuccessVerifyOtp }) => {
        return (
          <WSFlexBox.Center direction="column" alignItems="stretch" p="M">
            <WSText.Heading3 mb="S" align="center">
              Additional verification required
            </WSText.Heading3>
            <WSText.Paragraph color="grey700" mb="M" align="left">
              A 6 digit verification code has been sent <br />
              via SMS to your registered mobile number.
            </WSText.Paragraph>
            <WSForm
              onSubmit={data => onFormSubmit(data, onSuccessVerifyOtp)}
              validationSchema={Yup.object().shape({
                otp: Yup.string()
                  .required("OTP is required")
                  .matches(/^[0-9]+$/, "Must be only digits")
                  .min(6, "Must be exactly 6 digits")
                  .max(6, "Must be exactly 6 digits")
              })}
            >
              <WSForm.Field
                mb="XS"
                name="otp"
                component={WSTextInput}
                componentProps={{
                  autoFocus: true,
                  autoComplete: "one-time-code",
                  type: "tel",
                  formatOptions: {
                    numericOnly: true,
                    blocks: [6],
                    noImmediatePrefix: true,
                    rawValueTrimPrefix: true
                  }
                }}
              />
              <WSErrorMessage
                my="S"
                error={createOtpSessionMeta.error}
                contextKey={ErrorContextKey.CreateOtpSession}
              />
              <WSForm.SubmitButton
                name="confirmTwoFactorAuth"
                mt="XL"
                fullWidth
                loading={createOtpSessionMeta.isLoading}
              >
                Continue
              </WSForm.SubmitButton>
            </WSForm>
          </WSFlexBox.Center>
        );
      }}
    </WSModal>
  );
};

export interface SessionOTPModalProps {
  onSuccessVerifyOtp?: () => void;
  callbackUrl?: string;
}

export const useOpenSessionOTPModal = () => {
  const { openModal } = useModalContext();
  const openSessionOTPModal = (props: SessionOTPModalProps) => {
    openModal(SELECT_2FA_CHANNEL_FORM_MODAL, props);
  };
  return [openSessionOTPModal];
};
